import React from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ScorableTab, TabList, Tabs } from "@similarweb/ui-components";

import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import { i18nFilter } from "app/filters/i18nFilter";

const StyledTbs = styled(Tabs)<{ hideSelectedIndicator?: boolean }>`
    ${({ hideSelectedIndicator = false }) =>
        hideSelectedIndicator &&
        `
       .selected {
        &:after {
            border-bottom-color: transparent;
        }
    }
    `};
`;

function getLabelText(tab) {
    if (tab.labelText) {
        return i18nFilter()(tab.labelText);
    }
    if (tab.beta) {
        return i18nFilter()("mobileweb.switcher.beta");
    }
}

function getLabelColor(tab) {
    if (tab.isLocked) {
        return colorsPalettes.orange["400"];
    } else if (tab.beta) {
        return colorsPalettes.mint["400"];
    } else if (tab.labelColor) {
        return tab.labelColor;
    }
}

export class ScorableTabs extends React.Component<any, any> {
    public onTabSelected = (index: number, previous: number, event: Event) => {
        this.props.setSelected(this.props.tabs[index]);
        return true;
    };

    public render() {
        const dynamicFilter = dynamicFilterFilter();
        const selectedIndex = this.props.tabs.findIndex((tab) => tab.metric === this.props.selectedTab.metric);
        return (
            <StyledTbs
                selectedIndex={selectedIndex}
                onSelect={this.onTabSelected}
                hideSelectedIndicator={this.props.tabs.length < 2}
            >
                <TabList>
                    {this.props.tabs.map((tab, index) => {
                        const value = tab.value ?? null;
                        const {
                            id,
                            title,
                            metricDescription,
                            iconName,
                            tooltip,
                            valueChange,
                            invertChangeColors,
                            changeTooltip,
                            format,
                            valueChangeFormat,
                            valueChangeString,
                            enabled,
                        } = tab;
                        return (
                            <ScorableTab
                                key={id}
                                selected={index === selectedIndex}
                                metric={i18nFilter()(title)}
                                metricDescription={metricDescription}
                                metricIcon={iconName}
                                value={dynamicFilter(value, format)}
                                isLocked={tab.isLocked}
                                valueTooltip={tooltip ? i18nFilter()(tooltip) : null}
                                labelColor={getLabelColor(tab)}
                                labelText={getLabelText(tab)}
                                hideBorder={true}
                                valueChange={valueChange}
                                invertChangeColors={invertChangeColors}
                                changeTooltip={changeTooltip}
                                valueChangeFormat={valueChangeFormat}
                                valueChangeString={valueChangeString}
                                enabled={enabled}
                            />
                        );
                    })}
                </TabList>
                {this.props.children}
            </StyledTbs>
        );
    }
}
